import { useEffect, useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import NoDataList from "../../../../components/NoDataList";
import ProfileCard from "../../../../components/ProfileCard";
import { images } from "../../../../constants/images";
import { MyBuysProps } from "../../../../interfaces/components";
import styles from "./entryPoint.module.scss";
import { CircularProgress, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery } from "@mui/material";
import { addPointsInText } from "../../../../helpers/app";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Pagination from "../../../../components/Pagination";
import PurchaseCard from "../../../../components/PurchaseCard";

const EntryPoint = ({
    getMyBuysRequest,
    cleanMyBuys,
    fetchingMyBuys,
    myBuys,
    totalBuys,
    user,
    getDataPayment,
    dataPayment,
    getPaymentProcess,
    getCancellationPayment,
    getReservePublicationId,
    reservar
}: MyBuysProps) => {
    const params = useParams();
    const navigate = useNavigate();
    const [page, setPage] = useState<number>(1);
    const [totalMyBuys, setTotalMyBuys] = useState<number>(1);
    const [openModalPaymentReserve, setOpenModalPaymentReserve] = useState<boolean>(false);

    const handlePressRow = (id: string) => {
        navigate(`/perfil/mis_compras/${id}/gestion`);
    }

    useEffect(() => {
        if (fetchingMyBuys === "failure") {
            cleanMyBuys();
        }
        if (fetchingMyBuys === "success") {
            cleanMyBuys();
            setTotalMyBuys(Math.ceil(totalBuys / 20));
        }
    }, [fetchingMyBuys]); 

    useEffect(() => {
        getMyBuysRequest(page);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [page]);

   return (
    params.id
        ?
        <Outlet />
        :
        <div className={styles.myPublicationsContainer}>
            <div className={styles.headerContainer}>
                <h2 className={styles.title}>Mi actividad</h2>
            </div>

            {fetchingMyBuys === "loading"
                ?
                <div className={styles.loaderBuys} id="loaderBuys">
                    <CircularProgress
                        size={styles.loader}
                        classes={{ colorPrimary: styles.loader }}
                    />
                    <p className={styles.text}>Cargando compras</p>
                </div>
                :
                <>
                    {myBuys?.map((item: any) => (
                        <PurchaseCard
                            key={item._id}
                            publication={item}
                            onCancel={() => console.log('Cancel visit', item._id)}
                            onReschedule={() => console.log('Reschedule visit', item._id)}
                            onClick={() => handlePressRow(item._id)}
                            openModalPaymentReserve={openModalPaymentReserve}
                            setOpenModalPaymentReserve={setOpenModalPaymentReserve}
                            user={user}
                            getDataPayment={getDataPayment as any}
                            dataPayment={dataPayment}
                            getPaymentProcess={getPaymentProcess as any}
                            getCancellationPayment={getCancellationPayment as any}
                            getReservePublicationId={getReservePublicationId as any}
                            reservar={reservar}
                            publicationId={item._id}
                        />
                    ))}

                    {myBuys && myBuys.length > 0 &&
                        <Pagination
                            page={page}
                            setPage={setPage}
                            className={styles.pagination}
                            total={totalMyBuys}
                        />
                    }
                </>
            }
        </div>
)
};

export default EntryPoint;